var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgPtStopRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 125,
    viewBox: "0 0 67 125",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.5 12V124.5H60V103.5M66.5 12V1H1V12H60M66.5 12H60M60 12V99M60 99H39V103.5H60M60 99V103.5",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M47 12V16M47 16H57V34.5H5V16H14.5M47 16H14.5M14.5 16V12",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M53 31.5V19.5H9V31.5H53Z",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 21.5H24.5M15 21.5H11M50.5 27.5H24.5M15 25.5H11M50.5 23.5H24.5M50.5 25.5H24.5M50.5 29.5H24.5M15 23.5H11M15 27.5H11M15 29.5H11",
    stroke: "black",
    strokeWidth: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgPtStopRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/PTStopRight.8918113cb40bb1113bb955aea2309806.svg";